import { Link, createFileRoute } from "@tanstack/react-router";
import { LockClosedIcon } from "@heroicons/react/20/solid";
import Footer from "#/components/footer/footer";
import { metadataToHead } from "#/lib/seo";

const LoginPage = () => {
  return (
    <>
      <main>
        <div className="flex min-h-screen flex-col justify-center py-12 sm:px-6 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-md">
            <Link to="/">
              <img
                className="mx-auto h-12 w-auto"
                src="/roamdoc-logo.png"
                alt="Roamdoc logo"
                width={256}
                height={102}
              />
            </Link>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-sky-600">
              Log in to your account
            </h2>
          </div>

          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
              <form className="space-y-6" action="#" method="POST">
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Email address
                  </label>
                  <div className="mt-1">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      required
                      className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="password"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Password
                  </label>
                  <div className="mt-1">
                    <input
                      id="password"
                      name="password"
                      type="password"
                      autoComplete="current-password"
                      required
                      className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <input
                      id="remember-me"
                      name="remember-me"
                      type="checkbox"
                      className="h-4 w-4 rounded border-gray-300 text-sky-600 focus:ring-sky-500"
                    />
                    <label
                      htmlFor="remember-me"
                      className="ml-2 block text-sm text-gray-900"
                    >
                      Remember me
                    </label>
                  </div>

                  <div className="text-sm">
                    <Link
                      to="/account/reset-password"
                      className="font-medium text-sky-600 hover:text-sky-500"
                    >
                      Forgot your password?
                    </Link>
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    className="group relative flex w-full justify-center rounded-md border border-transparent bg-sky-600 px-4 py-2 text-sm font-medium text-white hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                  >
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                      <LockClosedIcon
                        className="h-5 w-5 text-sky-500 group-hover:text-sky-400"
                        aria-hidden="true"
                      />
                    </span>
                    Job Seeker Log In
                  </button>
                </div>
              </form>

              <div className="mt-6">
                <div className="relative">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-300"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="bg-white px-2 text-gray-500">
                      Or continue with
                    </span>
                  </div>
                </div>

                <div className="mt-6">
                  <div className="text-center">
                    <p className="text-sm font-medium text-gray-700">
                      Don't have an account?
                    </p>
                    <Link
                      to="/account/register"
                      className="font-medium text-sky-600 hover:text-sky-500"
                    >
                      Create an account
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default LoginPage;

export const metadata = {
  title: "Login • Roamdoc",
  description:
    "Log in and manage your Roamdoc account to help in your job search.",
  icons: [{ rel: "icon", url: "/favicon.ico" }],
  openGraph: {
    images: ["https://www.roamdoc.com/og-image.png"],
  },
  alternates: {
    canonical: `https://www.roamdoc.com/account/login`,
  },
};

export const Route = createFileRoute("/account/login/")({
  component: LoginPage,
  head: () => metadataToHead(metadata),
});
